import { FC } from "react";
import { Route, Switch } from 'react-router-dom';
import Shuttle from '../pages/shuttle';
import ShuttleDetail from '../pages/shuttle/detail';
import ShuttleSearch from '../pages/shuttle/search';

const ShuttleRouter: FC = () => {
  return (
    <Switch>
      <Route path='/' exact component={Shuttle} />
      <Route path='/detail' exact component={ShuttleDetail} />
      <Route path='/search' exact component={ShuttleSearch} />
    </Switch>
  );
}

export default ShuttleRouter;
